import { useDispatch, useSelector } from "react-redux";
import { togglePreguntaConfirmacionActiveThunk } from "../../store/reducers/preguntasConfirmacion/preguntasConfirmacion.thunks";
import Modal from "../UI/Modal";
import Loader from "../UI/Loader";
import { closeConfirmToggle } from "../../store/reducers/preguntasConfirmacion/preguntasConfirmacion.reducer";

const ConfirmToggleModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, togglePreguntaId, toggling } = useSelector(
    (state) => state.preguntasConfirmacion
  );

  const pregunta = useSelector((state) =>
    state.preguntasConfirmacion.list.find((p) => p.id === togglePreguntaId)
  );

  const handleConfirm = () => {
    dispatch(togglePreguntaConfirmacionActiveThunk(togglePreguntaId));
  };

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title="Confirmación"
      size="sm"
    >
      {toggling ? (
        <Loader center text="Actualizando pregunta..." type="dots" size="sm" />
      ) : (
        <>
          <p className="mb-3">
            ¿Seguro que quieres{" "}
            <strong>{pregunta?.is_active ? "desactivar" : "activar"}</strong> la
            pregunta <strong>"{pregunta?.pregunta}"</strong>?
          </p>

          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-secondary"
              onClick={() => dispatch(closeConfirmToggle())}
            >
              Cancelar
            </button>

            <button className="btn btn-primary" onClick={handleConfirm}>
              Confirmar
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleModal;
